import { __decorate } from "tslib";
import { formatHex } from '@1inch-community/core/formatters';
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { observe } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { defer, map } from 'rxjs';
import { notificationsMobileInfoStyle } from './notifications-mobile-info.style';
let NotificationsMobileInfoElement = class NotificationsMobileInfoElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
        this.addressView$ = defer(() => this.applicationContext.value.wallet.data.activeAddress$).pipe(map((address) => {
            if (!address)
                return '';
            const width = Math.max(Math.round(window.innerWidth / 25), 12);
            const head = Math.round(width / 2);
            const tail = width - head;
            return formatHex(address, { width, head, tail });
        }));
    }
    static { this.tagName = 'inch-notifications-mobile-info'; }
    static { this.styles = notificationsMobileInfoStyle; }
    render() {
        return html `
      <div class="grid-container">
        <inch-icon icon="logoFull"></inch-icon>
        <div class="address">
          <span>${observe(this.addressView$)}</span>
        </div>
      </div>
    `;
    }
};
NotificationsMobileInfoElement = __decorate([
    customElement(NotificationsMobileInfoElement.tagName)
], NotificationsMobileInfoElement);
export { NotificationsMobileInfoElement };
//# sourceMappingURL=notifications-mobile-info.element.js.map